<template>
  <ontick-modal :open="electronicSignature.isOpen" v-on:close="$emit('close')" size="small">
    <modal-header :data="electronicSignature.strategy" :selectedAccount="selectedAccount" />
    <transition v-on:enter="enter" v-on:leave="leave" v-bind:css="false" appear mode="out-in">
      <div v-if="!running_success" :key="1" class="space-y-6">
        <div class="flex items-center justify-center" v-if="electronicSignature.status == 'STOPPED'">
          <select-config type="setting" @change="optionSelected($event)"></select-config>
        </div>
        <modal-info-params
          v-if="
            selectedParameter.param_data &&
            electronicSignature.status == 'STOPPED' &&
            electronicSignature.strategy.type != 'PORTFOLIO'
          "
          :selectedParameter="selectedParameter"
          :selectedParameterInvestment="selectedParameterInvestment"
          :status="electronicSignature.status"
          :strategy="electronicSignature.strategy"
        />
        <!-- <modal-no-limit-alert-component
          v-if="electronicSignature.status === 'STOPPED'"
          :selectedParameter="selectedParameter"
          @confirmation="noLimitConfirmation = $event"
        /> -->
        <modal-stop-confirm
          v-if="electronicSignature.status == 'RUNNING'"
          @keyConfirm="keyupConfirmationText"
          :status="electronicSignature.status"
          :account_type="selectedAccount.account_type"
        />

        <modal-porfolio
          v-if="electronicSignature.strategy.type == 'PORTFOLIO' && electronicSignature.status == 'STOPPED'"
          :investments_ids="investments_ids"
          :account_id="selectedAccount.account_id"
          :investmentId="electronicSignature.investmentId"
          :running_success="init_strategy"
          @success="$emit('success')"
          @close="$emit('close')"
        />
        <div
          v-if="selectedAccount.account_type == 'PRD' && electronicSignature.status == 'STOPPED'"
          :class="[!selectedParameter.help_text ? 'mt-6' : 'mt-0']"
        >
          <h2 class="mb-3 text-center text-2xl">
            {{ title }}
          </h2>
          <p class="text-center text-xs">
            {{ description }}
          </p>

          <div class="input-wrapper my-3">
            <PincodeInput v-model="code" :secure="true" :characterPreview="false" :length="4" placeholder="0" />
            <div class="text-center">
              <a
                href="https://ajuda.ontick.com.br/portal/pt-br/kb/articles/como-gerar-nova-assinatura-eletronica-ontick"
                target="_blank"
                class="hover:text-ontick-blue-500 text-xs font-medium"
                >Esqueceu sua assinatura eletrônica? Clique aqui.</a
              >
            </div>
          </div>
        </div>
        <!-- <modal-buttons
          v-if="selectedParameter.param_data"
          :selectedAccount="selectedAccount"
          :loadingApi="loadingApi"
          :status="electronicSignature.status"
          :statusStrategy="init_strategy"
          :buttonDisabled="buttonDisabled"
          :parameterId="parameterId"
          :noLimitConfirmation="noLimitConfirmation"
          :riskAlert="selectedParameter.param_data.risk_alert"
          @confirmCode="
            $emit('confirmCode', code, parameterId, electronicSignature.status)
          "
          @stop="clickConfirmation"
        /> -->
        <modal-buttons
          :selectedAccount="selectedAccount"
          :selectedParameter="selectedParameter"
          :loadingApi="loadingApi"
          :status="electronicSignature.status"
          :statusStrategy="init_strategy"
          :buttonDisabled="buttonDisabled"
          :parameterId="parameterId"
          :noLimitConfirmation="noLimitConfirmation"
          @confirmCode="$emit('confirmCode', code, parameterId, electronicSignature.status)"
          @stop="clickConfirmation"
        />
      </div>

      <div v-else :key="2">
        <div class="py-12">
          <success
            :title="
              electronicSignature.strategy.type != 'PORTFOLIO'
                ? 'Estratégia iniciada com sucesso'
                : 'Portfólio iniciado com sucesso'
            "
            :active="running_success"
          />
        </div>
      </div>
    </transition>
  </ontick-modal>
</template>

<script>
import PincodeInput from "vue-pincode-input";
import { mapActions, mapGetters, mapState } from "vuex";
import EventBus from "@/app/shared/utils/event_bus";

export default {
  components: {
    PincodeInput,
    SelectConfig: () => import("./select-config.component.vue"),
    ModalStatus: () => import("./modal-status.component.vue"),
    ModalStopConfirm: () => import("./modal-stop-confirm.component.vue"),
    ModalInfoParams: () => import("./modal-start/modal-info-params.component.vue"),
    ModalNoLimitAlertComponent: () => import("./modal-start/modal-no-limit-alert.component.vue"),
    ModalPorfolio: () => import("./modal-start/modal-portfolio.component.vue"),
    ModalHeader: () => import("./modal-start/modal-header.component.vue"),
    ModalButtons: () => import("./modal-start/modal-buttons.component.vue"),
    Success: () => import("../../../../../shared/components/basic/ontick-success.component.vue"),
  },
  props: {
    loadingApi: { type: Boolean },
    running_success: { type: Boolean },
    investments_ids: { type: Array },
    electronicSignature: { type: Object },
    init_strategy: { type: Boolean },
  },

  data() {
    return {
      success_step: false,
      confirmationText: "",
      buttonDisabled: true,
      parameterId: null,
      code: "",
      title: "Assinatura eletrônica",
      description: "Digite sua assinatura eletrônica de 4 digitos para confirmar esta ação.",
      noLimitConfirmation: false,
    };
  },

  computed: {
    ...mapState({
      selectedAccount: (state) => state.accountTypes.selectedAccount,
      selectedParameter: (state) => state.investment.parameters.selectedParameter,
      selectedParameterInvestment: (state) => state.investment.selectedParameter,
    }),
    ...mapGetters({ getParameters: "investment/getParameters" }),
  },
  mounted() {
    const vm = this;
    EventBus.$on("CLEAN_ELECTRONIC_SIGNATURE", () => (this.code = ""));
    this.$nextTick(() => {
      this.getParameterSettings(this.electronicSignature.investmentId);
      // if (this.$refs.inputConfirmationText)
      //   this.$refs.inputConfirmationText.focus();

      // // Permite que ao pressionar a tecla ENTER, execute o investimento.
      // window.document
      //   .getElementsByClassName("vue-pincode-input")
      //   .forEach((pinCode) => {
      //     pinCode.addEventListener("keyup", function (event) {
      //       var key = event.which || event.keyCode;
      //       if (key == 13) {
      //         vm.$emit("confirmCode", vm.code, vm.parameterId, vm.status);
      //       }
      //     });
      //   });
    });
  },
  methods: {
    ...mapActions({
      getParameterSettings: "investment/getParameterSettings",
      selectedParam: "investment/selectedParam",
      // getParamInfo: "investment/getParamInfo",
    }),

    enter(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    optionSelected(event) {
      this.parameterId = event.param_id;
      this.selectedParam(this.getParameters.parameterSettings.find((item) => item.param_id === this.parameterId));
    },

    redirectEditParams() {
      this.$router.push({
        path: `/investments/${this.electronicSignature.investmentId}/edit`,
      });
    },

    keyupConfirmationText(event) {
      var key = event.which || event.keyCode;
      if (key == 13) {
        this.clickConfirmation();
      }
      this.confirmationText = event.target.value
        .replace(/[^\w\s]/gi, "")
        .replace(/\d+/g, "")
        .toLowerCase();
      if (event.target.value == "confirmar") {
        this.buttonDisabled = false;
      } else {
        this.buttonDisabled = true;
      }
    },

    clickConfirmation() {
      if (!this.buttonDisabled) {
        this.$emit(
          "confirmCode",
          this.confirmationText,
          this.selectedAccount.account_id,
          this.electronicSignature.status
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import "./electronic-signature.component.scss";
.fade-enter-active,
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  //   position: absolute;
  //   width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  // visibility: hidden;
  // position: absolute;

  width: 100%;
  opacity: 0;
}
</style>
